module.exports = __webpack_public_path__ + "images/icons_v2/donation-49e57943.svg";